
import { TOGGLE_STATUS, SET_NAVIGATION } from './mutation-types'

export default {
	[TOGGLE_STATUS] (state) {
		state.status = (state.status === 'closed') ? 'open' : 'closed'
	},
	[SET_NAVIGATION] (state, navigation) {
		state.navigation = navigation
	}
}
